module.exports = __webpack_public_path__ + "om.289c4ffe.svg";